import React, { useEffect, useRef, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import styles from './GalleryPage.module.css';
import ReservationSection from '../../sections/ReservationSection/ReservationSection';

const GalleryPage = () => {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [photos, setPhotos] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch images from Firestore — same source as FoodGalleryCarousell
    useEffect(() => {
        const fetchImages = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, 'food-gallery'));
                const imageUrls = querySnapshot.docs
                    .map((doc) => doc.data().imageUrl)
                    .filter(Boolean); // drop any undefined/null
                setPhotos(imageUrls);
            } catch (error) {
                console.error('Error fetching gallery images:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchImages();
    }, []);

    // Intersection observer for reveal animation
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setVisible(true);
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <main
                ref={sectionRef}
                className={`${styles.wrapper} ${visible ? styles.show : ''}`}
            >
                <div className={styles.container}>
                    {/* Timeline Header Section */}
                    <header className={styles.header}>
                        <h1 className={styles.title}>Gallery</h1>
                        <div className={styles.timelineWrapper}>
                            <div className={styles.line}></div>
                            <div className={styles.stars}>
                                <span className={styles.star} style={{ transitionDelay: '200ms' }}>✦</span>
                                <span className={styles.star} style={{ transitionDelay: '400ms' }}>✦</span>
                                <span className={styles.star} style={{ transitionDelay: '600ms' }}>✦</span>
                            </div>
                        </div>
                    </header>

                    {/* Loading state */}
                    {loading && (
                        <div className={styles.loader}>Loading Gallery...</div>
                    )}

                    {/* Empty state */}
                    {!loading && photos.length === 0 && (
                        <div className={styles.empty}>No photos available.</div>
                    )}

                    {/* Gallery Grid */}
                    {!loading && photos.length > 0 && (
                        <section className={styles.grid}>
                            {photos.map((src, index) => (
                                <div
                                    key={index}
                                    className={styles.photoBox}
                                    style={{ transitionDelay: `${(index % 3) * 150 + 400}ms` }}
                                >
                                    <img
                                        src={src}
                                        alt={`Gallery item ${index + 1}`}
                                        loading="lazy"
                                    />
                                </div>
                            ))}
                        </section>
                    )}
                </div>
            </main>

            <ReservationSection />
        </>
    );
};

export default GalleryPage;